import { inject } from '@angular/core'
import { StorybookTranslationsService } from '@bonduelle-it/storybook'
import { TranslateLoader, TranslationObject } from '@ngx-translate/core'
import { catchError, defer, forkJoin, from, map, Observable } from 'rxjs'

export class TranslationsLoader implements TranslateLoader {
  private sbTranslations = inject(StorybookTranslationsService)

  getTranslation(lang: string): Observable<TranslationObject> {
    const loadApp = (l: string) =>
      from(import(`../assets/i18n/${l}.json`)).pipe(
        map((m) => m.default),
        catchError(() => from(import(`../assets/i18n/en-us.json`)).pipe(map((m) => m.default))),
      )

    const loadStorybook = (l: string) =>
      defer(() => from(this.sbTranslations.load(l))).pipe(catchError(() => from(this.sbTranslations.load('en-us'))))

    return forkJoin({
      app: loadApp(lang),
      storybook: loadStorybook(lang),
    }).pipe(
      map(({ app, storybook }) => {
        const mergedTranslations = {
          ...app,
          ...storybook,
        }

        return mergedTranslations
      }),
    )
  }
}
